{
  "loading": "Chargement en cours…"
}
